import axios, { BASE_URL } from "../axios";
import BaseModel from "./baseModel";

export default class ExternalIntegrationModel extends BaseModel {
  static endPoint = "external-integrations/";

  /**
   * Ask the portal backend to run this integration (e.g. upload_pdf_result: server fetches PDF and POSTs to partner).
   * @param {string} id - Integration document id
   * @param {{ orderId: string, endpointIndex?: number }} body - portal order id; optional index when one doc has multiple legacy endpoints
   */
  static execute(id, body) {
    return axios.post(`${BASE_URL}${this.endPoint}${id}/execute`, body);
  }
}
